import { apiClient } from "./client";
import { ApiResponse } from "../types";

export interface CreateIssueRequest {
  project_id: string;
  workspace_id: string;
  issue_status_id?: string;
  name?: string;
  value?: string;
  execution_environment_ids?: string[];
  build_version_ids?: string[];
}

export interface CreateIssueResponse {
  issue: any;
}

export class IssueAPI {
  static async createIssue(
    req: CreateIssueRequest
  ): Promise<ApiResponse<CreateIssueResponse>> {
    return apiClient.post<CreateIssueResponse>("/issue/create", req);
  }
}

export default IssueAPI;
